import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Auto-scrolls to and pulses an element matching a URL query param.
 *
 * @param {string} paramName  - e.g. 'sku', 'ticket', 'log'
 * @param {string} testIdPrefix - e.g. 'sku-row-' (matched against data-testid attribute)
 * @param {Array}  deps - extra deps to re-run after data has loaded
 */
export default function useDeepLinkHighlight(paramName, testIdPrefix, deps = []) {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const target = params.get(paramName);
    if (!target) return;

    // Wait a moment for the data to render, then scroll + pulse
    const timer = setTimeout(() => {
      const el = document.querySelector(`[data-testid="${testIdPrefix}${target}"]`);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('deep-link-pulse');
      setTimeout(() => el.classList.remove('deep-link-pulse'), 2500);
    }, 400);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, ...deps]);
}
